import classNames from 'clsx';
import React from 'react';

import AsyncSelectInput, { AsyncSelectInputProps } from '../input/AsyncSelectInput';
import BaseInputProps from '../input/BaseInputProps';
import DateInput, { DateInputProps } from '../input/DateInput';
import DynamicTextInput, { DynamicTextInputProps } from '../input/DynamicTextInput';
import NumericMoneyInput, { NumericMoneyInputProps } from '../input/NumericMoneyInput';
import SelectInput, { SelectInputProps } from '../input/SelectInput';
import TextInput, { EmailInput, TextInputProps } from "../input/TextInput";
import TextSelectInput, { TextSelectInputProps } from '../input/TextSelectInput';

import NoticeMessage, { NoticeField } from './NoticeMessage';

export const REGEX_LINKEDIN_URL =
  /\s*((https?:\/\/)?((www|\w\w)\.)?linkedin\.com\/in\/([-\w|\d&#?=ç¨´-øµ˚])+\/?)+\/?\s*/i;

export const linkedinValidation = {
  regex: REGEX_LINKEDIN_URL,
  regexError: 'Invalid LinkedIn url',
};

export const REGEX_PHONE_NUMBER = /^\+?[0-9]{1,3}[-. (]*[0-9]{1,3}[-. )]*[0-9]{1,4}$/;
export const phoneNumberValidation = {
  regex: REGEX_PHONE_NUMBER,
  regexError: 'Invalid phone number',
};

export const REGEX_URL = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/i;

interface BlankField extends BaseInputProps {
  type: 'blank';
}

interface NumericMoneyField extends NumericMoneyInputProps {
  type: 'numeric';
}

interface TextField extends TextInputProps {
  type: 'text';
}

interface EmailField extends TextInputProps {
  type: 'email';
}

interface DateField extends DateInputProps {
  type: 'date';
}

interface DynamicTextField extends DynamicTextInputProps {
  type: 'dynamicText';
}

interface SelectField extends SelectInputProps {
  type: 'select';
}

interface MultiSelectField extends TextSelectInputProps {
  type: 'multiSelect';
}

interface AsyncSelect extends AsyncSelectInputProps {
  type: 'asyncSelect';
}

export type Field = BlankField |
  NumericMoneyField |
  TextField |
  EmailField |
  DynamicTextField |
  DateField |
  NoticeField | 
  SelectField | 
  MultiSelectField |
  AsyncSelect;

interface FieldComponentProps {
  field: Field;
}

export default function FieldComponent({ field }: FieldComponentProps) {
  switch (field.type) {
    case 'blank':
      return <div className={classNames("ml-2 flex flex-col mb-4 w-full md:w-1/2 px-2")} />;
    case 'notice':
      return <NoticeMessage {...field} />;
    case 'numeric':
      return <NumericMoneyInput {...field} customWidth='w-full md:w-1/2' />;
    case 'text':
      return <TextInput {...field} customWidth='w-full md:w-1/2' />;
    case 'email':
      return <EmailInput {...field} customWidth='w-full md:w-1/2'/>;
    case 'select':
      return <SelectInput {...field} customWidth='w-full md:w-1/2' />;
    case 'dynamicText':
      return <DynamicTextInput {...field} customWidth='w-full md:w-1/2'/>;
    case 'asyncSelect': 
      return <AsyncSelectInput {...field} customWidth='w-full md:w-1/2' />;
    case 'multiSelect':
      return <TextSelectInput {...field} customWidth='w-full md:w-1/2'/>;
    case 'date':
      return <DateInput {...field} customWidth='w-full md:w-1/2'/>;
    default:
      return null;
  }
};
